export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
  isHot: boolean;
  isTop: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '震惊！某顶流男星深夜密会神秘女子，两人举止亲密疑似恋情曝光',
    excerpt: '近日，某顶流男星被拍到深夜与一名神秘女子在某高档餐厅共进晚餐，两人举止亲密，疑似新恋情曝光。据目击者称，两人在餐厅包间内待了将近三个小时...',
    content: `<p>近日，有媒体拍到某知名顶流男星在深夜与一名神秘女子在某高档餐厅共进晚餐的画面。</p>
    <p>据目击者透露，当天晚上约10点左右，该男星戴着口罩和帽子低调现身某高档日料店，随后一名身穿黑色连衣裙的长发女子也进入同一家餐厅。两人在包间内共处了将近三个小时，直到凌晨1点才先后离开。</p>
    <p>从拍到的画面来看，该女子身材高挑，气质出众，虽然同样戴着口罩，但依然能看出颜值不俗。两人离开时虽然刻意保持距离，但有细心网友发现两人佩戴了同款手链，这一细节引发网友热议。</p>
    <p>该男星此前曾在采访中表示自己目前单身，专注于事业发展。此次被拍到与神秘女子共进晚餐，是否意味着恋情有了新进展？还是只是普通朋友聚餐？</p>
    <p>截至目前，双方团队均未对此事作出回应。不少粉丝在社交平台上表示："如果是真的就祝福"，也有部分粉丝持怀疑态度，认为可能是新剧宣传的一部分。</p>
    <p>我们将持续关注此事的最新进展。</p>`,
    category: 'yule-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20nighttime%20scene%20of%20a%20stylish%20couple%20leaving%20a%20high-end%20restaurant%20in%20a%20big%20city%2C%20paparazzi%20style%20photography%2C%20warm%20golden%20street%20lights%2C%20cinematic%20mood%2C%20blurred%20background%2C%20soft%20focus%2C%20glamorous%20celebrity%20vibe&width=800&height=450&seq=article-cover-1&orientation=landscape',
    author: '娱乐小侦探',
    publishDate: '2026-08-03',
    readCount: 1258000,
    tags: ['顶流男星', '恋情曝光', '深夜约会', '娱乐圈'],
    isHot: true,
    isTop: true,
  },
  {
    id: 'article-2',
    title: '某热播剧女主被曝片场耍大牌，导演组集体不满？真相来了',
    excerpt: '近日，有网友爆料称某热播剧女主在片场频繁迟到、对工作人员态度恶劣，引发导演组集体不满。记者多方求证后，发现事情并非表面那么简单...',
    content: `<p>近日，一则关于某热播剧女主角在片场"耍大牌"的消息在网络上疯传。据自称剧组工作人员的网友爆料，该女星在拍摄期间频繁迟到，有时甚至迟到两三个小时，让全剧组苦等。此外，还称其对化妆师和场务人员态度恶劣，引发导演组集体不满。</p>
    <p>然而，记者通过多方渠道求证后发现，事情可能并非表面那么简单。据另一位知情人士透露，该女星确实有过迟到的情况，但主要是因为拍摄档期安排过于紧凑，她需要在两个城市之间频繁往返。"她其实非常敬业，经常拍到凌晨，有时候一天只能睡三四个小时。"</p>
    <p>至于"态度恶劣"的指控，有现场工作人员表示："她只是对工作质量要求比较高，有时候会直接指出问题所在，可能语气急了点，但绝对没有恶意。"</p>
    <p>该剧导演在接受采访时也力挺女主角："她是我合作过最认真的演员之一，我们对她的专业态度非常认可。网络上的传言并不属实。"</p>
    <p>业内人士分析认为，此类负面消息很可能是竞争对手的恶意抹黑。在当前流量为王的时代，一部热播剧的主演往往会成为各种是非的焦点。</p>`,
    category: 'yingshi-zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20film%20set%20with%20professional%20cameras%20and%20lighting%20equipment%2C%20crew%20members%20working%2C%20dramatic%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20movie%20production%20environment&width=800&height=450&seq=article-cover-2&orientation=landscape',
    author: '圈内知情人',
    publishDate: '2026-08-03',
    readCount: 987000,
    tags: ['热播剧', '女主角', '片场风波', '耍大牌'],
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-3',
    title: '独家！某当红女团成员被曝与富二代男友已秘密领证',
    excerpt: '据可靠消息源透露，某当红女团人气成员已与相恋多年的富二代男友于上个月秘密领证结婚。消息一出，粉丝圈瞬间炸开了锅...',
    content: `<p>独家消息！据多位可靠消息源向本网透露，某当红女团人气成员已与相恋多年的富二代男友于上个月在某民政局秘密领证结婚。</p>
    <p>据悉，两人相识于三年前的一场慈善晚宴，男方为某知名企业集团的继承人，身价不菲。两人交往以来一直保持低调，很少在公开场合同框，但知情人透露两人感情一直非常稳定。</p>
    <p>"他们选择秘密领证主要是因为不想让婚事成为公众焦点，希望保护彼此的隐私。"一位与女方关系密切的朋友告诉记者。</p>
    <p>该女团成员今年25岁，正处于事业上升期。她所在的女团刚刚发布了新专辑，销量成绩亮眼。此次被曝秘密结婚，对其事业发展是否会产生影响，引发外界广泛关注。</p>
    <p>粉丝对此反应不一。有粉丝表示祝福："姐姐终于找到幸福了！"也有粉丝表示心碎："我的青春结束了。"更有粉丝质疑消息真实性，要求当事人出面澄清。</p>
    <p>截至目前，女方经纪公司尚未对此事作出正式回应。</p>`,
    category: 'yule-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20wedding%20rings%20on%20a%20silk%20pillow%20with%20soft%20romantic%20lighting%2C%20luxury%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20warm%20golden%20tones%2C%20dreamy%20atmosphere&width=800&height=450&seq=article-cover-3&orientation=landscape',
    author: '独家爆料组',
    publishDate: '2026-08-02',
    readCount: 1560000,
    tags: ['女团成员', '秘密领证', '富二代', '独家爆料'],
    isHot: true,
    isTop: true,
  },
  {
    id: 'article-4',
    title: '某综艺节目录制现场突发意外，现场观众全部被紧急疏散',
    excerpt: '昨日晚间，某热门综艺节目在录制过程中突发舞台设备故障，现场冒出浓烟，节目组当机立断疏散了全部现场观众。目前事故原因正在调查中...',
    content: `<p>昨日晚间8时许，某热门综艺节目在北京某影视基地录制时突发意外。据现场观众描述，录制进行到一半时，舞台上方的一个灯光设备突然冒出浓烟，并伴有轻微的爆裂声。</p>
    <p>"当时大家都很紧张，但节目组反应很快，主持人立刻让大家保持冷静，工作人员迅速引导我们从最近的出口疏散。"一位现场观众回忆道。</p>
    <p>节目组在事故发生后第一时间启动了应急预案，约500名现场观众在15分钟内全部安全疏散，所幸无人受伤。消防人员随后赶到现场进行处理。</p>
    <p>该节目制作方随后发布声明称："录制过程中确实发生了设备故障，我们已经第一时间处理，并对给现场观众带来的不便深表歉意。目前设备已在全面检修中，节目将择期恢复录制。"</p>
    <p>值得一提的是，该节目此前已多次因安全问题被网友吐槽。有业内人士透露，此次事故可能与设备老化和维护不到位有关。</p>
    <p>广电部门表示已关注此事，将对该节目制作方的安全保障措施进行核查。</p>`,
    category: 'zongyi-yule',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20set%20with%20stage%20lights%20and%20equipment%2C%20slightly%20smoky%20atmosphere%2C%20emergency%20lights%20glowing%2C%20dramatic%20scene%2C%20behind%20the%20scenes%20television%20production&width=800&height=450&seq=article-cover-4&orientation=landscape',
    author: '安全第一线',
    publishDate: '2026-08-02',
    readCount: 723000,
    tags: ['综艺节目', '录制意外', '紧急疏散', '安全事故'],
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-5',
    title: '某知名导演被前助理实名举报潜规则，晒出多段录音证据',
    excerpt: '今日凌晨，一位自称是某知名导演前助理的网友在社交平台发布长文，实名举报该导演在合作期间多次对其进行骚扰和威胁...',
    content: `<p>今日凌晨，一位微博认证为"前影视从业者"的网友发布了一篇长达3000字的举报文章，实名指控某知名导演在与其共事期间多次实施骚扰和威胁行为，并晒出了多段录音作为证据。</p>
    <p>该举报人自称曾在2019年至2022年间担任该导演的私人助理。在长文中，她详细描述了导演如何利用职务之便，在出差、应酬等场合对其进行不当行为，并在她拒绝后以"业内封杀"相威胁。</p>
    <p>"我一直很害怕，但是看到越来越多的受害者勇敢站出来，我也决定不再沉默。"举报人在文中写道。</p>
    <p>她公布的录音中，可以清晰听到一名男性声音说出不当言论。虽然举报人对录音中的当事人做了变声处理，但从对话内容来看，与举报人的描述高度吻合。</p>
    <p>此事迅速登上热搜，引发全网热议。不少网友对举报人表示支持："勇敢的女孩，我们支持你！"也有网友呼吁不要轻信单方面指控，等待更多证据。</p>
    <p>截至目前，被指控的导演方面尚未作出回应。该导演最近一部作品刚刚杀青，原定于下月上映，此次事件是否会影响影片的正常宣发，尚不可知。</p>`,
    category: 'shehui-redian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20silhouette%20of%20a%20person%20holding%20a%20phone%20with%20voice%20recording%20app%20open%2C%20dark%20moody%20background%2C%20symbolic%20representation%20of%20whistleblowing%2C%20high%20contrast%20lighting&width=800&height=450&seq=article-cover-5&orientation=landscape',
    author: '深度调查',
    publishDate: '2026-08-01',
    readCount: 2130000,
    tags: ['实名举报', '潜规则', '导演', '录音证据'],
    isHot: true,
    isTop: true,
  },
  {
    id: 'article-6',
    title: '某流量小生被拍到在商场与粉丝互殴？现场视频流出',
    excerpt: '一段某流量小生在商场与粉丝发生肢体冲突的视频在网上疯传。视频显示双方因拍照问题爆发争执，最终演变为互殴。网友们对此事件看法不一...',
    content: `<p>一段时长约2分钟的短视频今日在各大社交平台疯传。视频中，一位当红流量小生在某大型商场内与一名疑似粉丝的男子发生激烈冲突，双方从口角争执迅速升级为肢体冲突。</p>
    <p>据目击者描述，事发原因是该粉丝在未经允许的情况下近距离跟拍该明星，明星方面多次劝阻无效后，双方发生争执。"那个男的追着拍了很久，明星让他删掉照片他不肯，然后就打起来了。"</p>
    <p>视频中可以看到，场面一度非常混乱，商场保安迅速介入将双方分开。所幸双方均未受到严重伤害。</p>
    <p>此事在网络上引发两极分化的评论。一部分网友支持明星维权："私生饭就应该被教训，明星也有隐私权！"另一部分网友则认为明星作为公众人物，应该更加克制："再怎么样也不能动手打人啊。"</p>
    <p>该明星工作室于当日下午发布声明，对冲突事件表示遗憾，但同时强调"将坚决维护艺人的合法权益，对过度侵犯隐私的行为零容忍。"</p>
    <p>法律界人士指出，根据相关法律规定，未经允许进行近距离拍摄可能构成对他人隐私权的侵犯。但同时，以暴力方式处理纠纷也可能面临法律风险。</p>`,
    category: 'mingxing-dongtai',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20busy%20shopping%20mall%20interior%20with%20people%2C%20security%20guards%20intervening%20in%20a%20crowd%2C%20dramatic%20moment%20captured%2C%20blurred%20motion%2C%20bright%20mall%20lighting&width=800&height=450&seq=article-cover-6&orientation=landscape',
    author: '现场直击',
    publishDate: '2026-08-01',
    readCount: 1840000,
    tags: ['流量小生', '粉丝冲突', '商场斗殴', '隐私权'],
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-7',
    title: '重磅！某国际奢侈品牌官宣新代言人，人气女星拿下千万合约',
    excerpt: '今日上午，某国际奢侈品牌正式官宣人气女星成为其全新品牌代言人，据悉合约金额高达八位数。这也是该品牌首次启用中国面孔作为全球代言人...',
    content: `<p>今日上午10点，某国际一线奢侈品牌在官方社交平台正式宣布，人气女星林某某成为其全新品牌全球代言人。这也是该品牌创立近百年来，首次启用中国面孔作为全球范围的品牌代言人。</p>
    <p>据悉，此次代言的合约金额高达八位数人民币，合作范围涵盖成衣、配饰、香水等多个产品线。品牌方表示，选择林某某是因为她"完美诠释了现代东方女性的优雅与力量，与品牌精神高度契合。"</p>
    <p>林某某也在个人社交平台上分享了这一消息："非常荣幸能够加入这个百年品牌的大家庭，期待与品牌一起创造更多美好的时刻。"该条动态发布后不到一小时，点赞数便突破百万。</p>
    <p>时尚圈人士分析认为，越来越多国际奢侈品牌开始重视中国市场，选择中国面孔作为全球代言人，反映了中国消费市场在全球奢侈品行业中的重要地位。</p>
    <p>据了解，林某某近年在国际时尚圈的表现可圈可点，先后登上了多家国际顶级时尚杂志的封面，在国际时装周上的亮相也获得了广泛好评。</p>`,
    category: 'shishang-shenghuo',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20brand%20press%20conference%20scene%2C%20elegant%20atmosphere%2C%20golden%20champagne%20decor%2C%20sophisticated%20lighting%2C%20high%20fashion%20event%20setting&width=800&height=450&seq=article-cover-7&orientation=landscape',
    author: '时尚先锋',
    publishDate: '2026-07-31',
    readCount: 675000,
    tags: ['奢侈品牌', '代言人', '人气女星', '时尚'],
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-8',
    title: '某知名运动员退役后进军娱乐圈？综艺首秀表现惊艳',
    excerpt: '前奥运冠军在某热门综艺节目中的表现引发热议。其幽默的谈吐和超强的综艺感让观众直呼"被体育耽误的综艺咖"...',
    content: `<p>前奥运冠军张某某在某热门真人秀综艺中的首秀表现，让许多观众眼前一亮。这位曾经在赛场上以严肃著称的运动员，在节目中展现了完全不同的另一面。</p>
    <p>在节目中，张某某不仅展现了令人捧腹的幽默感，还在游戏环节中凭借出色的体能优势多次帮助团队取胜。"我本来以为他会很严肃很无聊，没想到这么好笑！"一位观众在社交平台上这样评价。</p>
    <p>据悉，张某某自去年正式宣布退役后，便签约了某知名经纪公司，正式进军娱乐圈。除了综艺节目，他还参与了多部影视作品的拍摄。</p>
    <p>"运动员转型娱乐圈并不罕见，但能够如此快速地获得观众认可的并不多。"一位娱乐圈资深评论人士表示，"他的真诚和努力是最打动人的地方。"</p>
    <p>张某某在接受采访时表示："运动员和艺人其实有很多共通之处，都需要不断突破自己。我希望能在新的领域里继续发光发热。"</p>
    <p>据统计，该期节目的收视率创下了本季节目的新高，张某某的精彩表现功不可没。</p>`,
    category: 'tiyu-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20variety%20show%20studio%20with%20colorful%20stage%20lights%20and%20game%20props%2C%20energetic%20atmosphere%2C%20bright%20studio%20lighting%2C%20entertainment%20TV%20production%20set&width=800&height=450&seq=article-cover-8&orientation=landscape',
    author: '跨界观察者',
    publishDate: '2026-07-31',
    readCount: 542000,
    tags: ['运动员', '娱乐圈', '综艺首秀', '跨界'],
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-9',
    title: '某热门网剧第二季官宣定档！原班人马回归，剧情全面升级',
    excerpt: '备受期待的某热门网剧第二季正式官宣定档8月15日，原班人马全员回归。据悉第二季在制作规模和剧情深度上均有大幅升级...',
    content: `<p>千呼万唤始出来！某热门网剧的第二季终于正式官宣定档8月15日，将在某视频平台独家播出。令粉丝们欣喜的是，第二季实现了原班人马全员回归的承诺。</p>
    <p>该剧第一季于去年播出后口碑收视双丰收，豆瓣评分高达8.5分，累计播放量突破50亿。第一季大结局留下的诸多悬念，也将在第二季中一一揭晓。</p>
    <p>据制片人透露，第二季在制作规模上有明显升级："我们投入了第一季三倍的制作预算，在场景、特效、服装等方面都做了全面升级。故事情节也会更加丰富立体，人物关系更加复杂。"</p>
    <p>主演们也在社交媒体上表达了对第二季的期待。男主在微博发文："等待了这么久，终于可以和大家见面了。这一季的故事，绝对不会让大家失望。"</p>
    <p>业内分析人士认为，该剧第二季有望成为今年暑期档的最大爆款。随着定档消息的发布，"XX第二季定档"的话题迅速登上微博热搜榜首。</p>`,
    category: 'yingshi-zixun',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20movie%20poster%20photoshoot%20scene%20with%20professional%20lighting%20setup%2C%20cinematic%20atmosphere%2C%20film%20production%20aesthetic%2C%20warm%20dramatic%20tones&width=800&height=450&seq=article-cover-9&orientation=landscape',
    author: '剧集追踪',
    publishDate: '2026-07-30',
    readCount: 892000,
    tags: ['网剧', '第二季', '定档', '原班人马'],
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-10',
    title: '某知名网红直播带货翻车，产品被指虚假宣传，或将面临巨额赔偿',
    excerpt: '拥有千万粉丝的某知名网红在最近一场直播带货中推广的某美容产品被消费者实名投诉虚假宣传，市场监管部门已介入调查...',
    content: `<p>拥有超过两千万粉丝的某知名网红近日陷入直播带货争议。其在上周一场直播中大力推荐的某美容产品，被多位消费者实名投诉存在虚假宣传问题。</p>
    <p>据投诉者反映，该网红在直播中声称产品"使用一周即可看到明显效果"，并展示了许多"前后对比照"。然而，大量消费者在购买使用后表示"完全没有任何效果"，甚至有消费者反映使用后出现了皮肤过敏的情况。</p>
    <p>"我当时就是看她的推荐才买的，花了好几百块，结果完全就是智商税。"一位消费者在接受采访时气愤地表示。</p>
    <p>更令人震惊的是，有网友发现该网红在直播中使用的"对比照"疑似是从其他品牌宣传材料中截取的，而非该产品的真实效果图。</p>
    <p>目前，当地市场监管部门已对此事展开调查。法律专家指出，如果虚假宣传的指控成立，该网红可能面临巨额赔偿，甚至可能承担相应的法律责任。</p>
    <p>该网红目前尚未对此事作出公开回应，但其社交账号的评论区已经被愤怒的消费者"攻陷"。</p>`,
    category: 'wangluo-chigua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20studio%20setup%20with%20ring%20light%20and%20products%20on%20display%2C%20modern%20streamer%20equipment%2C%20bright%20lighting%2C%20e-commerce%20live%20streaming%20environment&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '消费维权站',
    publishDate: '2026-07-30',
    readCount: 1340000,
    tags: ['网红', '直播带货', '虚假宣传', '消费维权'],
    isHot: true,
    isTop: false,
  },
  {
    id: 'article-11',
    title: '某剧组被曝拖欠群演工资，上百人群情激愤围堵拍摄现场',
    excerpt: '某正在拍摄中的古装剧剧组被曝出拖欠群演工资长达两个月，上百名群众演员昨日围堵拍摄现场讨薪...',
    content: `<p>昨日，某正在横店影视城拍摄的古装大剧剧组被上百名群众演员围堵讨薪。据现场群演反映，剧组已拖欠他们工资长达两个月之久。</p>
    <p>"我们每天凌晨三四点就起来化妆，有时候拍一整天连饭都顾不上吃，结果两个月了工资一分钱没见着。"一位群演代表气愤地告诉记者。</p>
    <p>据了解，该剧投资规模不小，主演阵容也颇为强大。然而在光鲜亮丽的外表之下，底层演职人员却面临着被拖欠工资的困境。群演们表示，他们多次向剧组反映此问题，但每次都被以"资金周转困难"为由搪塞过去。</p>
    <p>事件发生后，当地劳动监察部门已介入协调。在多方压力下，剧组方面承诺将在三个工作日内结清全部欠薪。</p>
    <p>该事件的曝光也引发了社会对影视行业底层从业者权益保护的广泛讨论。有业内人士指出，群演作为影视产业链中最弱势的环节，其权益保障问题长期被忽视，亟需行业规范和制度保障。</p>`,
    category: 'shehui-redian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20a%20crowd%20of%20extras%20in%20costumes%20gathered%20outside%2C%20protest%20atmosphere%2C%20Chinese%20historical%20drama%20setting%2C%20dramatic%20outdoor%20scene&width=800&height=450&seq=article-cover-11&orientation=landscape',
    author: '底层观察',
    publishDate: '2026-07-29',
    readCount: 456000,
    tags: ['剧组', '拖欠工资', '群演', '横店'],
    isHot: false,
    isTop: false,
  },
  {
    id: 'article-12',
    title: '某知名歌手新专辑涉嫌抄袭？网友扒出多首歌曲相似度极高',
    excerpt: '某知名歌手刚刚发布的新专辑被网友质疑抄袭多首海外歌曲。音乐博主通过专业软件进行对比分析后发现，多首歌曲的旋律相似度超过70%...',
    content: `<p>某知名歌手于上周五发布的新专辑《XX》在取得不错销售成绩的同时，也陷入了抄袭争议。多位网友及音乐博主指出，专辑中的多首歌曲与海外歌手的作品存在高度相似。</p>
    <p>一位拥有百万粉丝的音乐博主专门制作了对比视频，通过音频分析软件将疑似抄袭的歌曲与"原曲"进行波形对比。结果显示，有至少三首歌曲的旋律相似度超过70%。</p>
    <p>"这已经不是'雷同'可以解释的程度了。"该博主在视频中表示。</p>
    <p>争议发酵后，该歌手所属的唱片公司发表声明否认抄袭指控，称"所有歌曲均为原创作品，旋律上的相似可能源于音乐风格的趋同。"</p>
    <p>然而，这一回应并未平息质疑。被指"被抄袭"的某海外歌手的粉丝也在社交媒体上发声，要求国内歌手方面给出合理解释。</p>
    <p>知识产权律师表示，音乐抄袭的认定在司法实践中较为复杂，需要综合考虑旋律、和声、节奏等多个因素。但如果抄袭指控最终成立，歌手和唱片公司可能面临侵权赔偿。</p>`,
    category: 'yule-bagua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20music%20recording%20studio%20with%20microphone%20and%20audio%20equipment%2C%20creative%20atmosphere%2C%20professional%20music%20production%20environment%2C%20warm%20studio%20lighting&width=800&height=450&seq=article-cover-12&orientation=landscape',
    author: '音乐圈内人',
    publishDate: '2026-07-29',
    readCount: 1100000,
    tags: ['歌手', '抄袭', '新专辑', '音乐对比'],
    isHot: true,
    isTop: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((article) => article.isHot);
};

export const getTopArticles = (): Article[] => {
  return articles.filter((article) => article.isTop);
};

export const getRelatedArticles = (article: Article, limit: number = 4): Article[] => {
  return articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .slice(0, limit);
};

export const getTrendingArticles = (limit: number = 10): Article[] => {
  return [...articles].sort((a, b) => b.readCount - a.readCount).slice(0, limit);
};

export const getLatestArticles = (limit: number = 8): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
};